// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0LlDv","default":"styles_default__OCjkM","small":"styles_small__cR2r-","fadeIn":"styles_fadeIn__Xsi9-"};